import React, { Component } from "react";
import { AsyncStorage } from "react-native";
import { Redirect, Route } from "react-router-dom";
import { Storage } from "utils/storage";

//Mock of an Auth method, can be replaced with an async call to the backend. Must return true or false

const PRIVATE_ROOT = "/";
const PUBLIC_ROOT = "/login";

class AuthRoute extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		AsyncStorage.getItem("login").then(res => {
			const val = res == "true";

			if (val != this.state.loggedIn) {
				this.setState({
					loggedIn: val,
				});
			}
		});
	}

	render() {
		const { isPrivate, notFoundPage, bypass } = this.props.component;
		let route = null;

		if (notFoundPage || bypass) {
			return <Route {...this.props} component={this.props.component} />;
		}

		if (this.state.loggedIn) {
			//User is Authenticated
			if (isPrivate === true) {
				//If the route is private the user may proceed.
				route = (
					<Route {...this.props} component={this.props.component} />
				);
			} else {
				//If the route is public, the user is redirected to the app's private root.
				route = <Redirect to={PRIVATE_ROOT} />;
			}
		} else {
			//User is not Authenticated
			if (isPrivate === true) {
				//If the route is private the user is redirected to the app's public root.
				route = <Redirect to={PUBLIC_ROOT} />;
			} else {
				//If the route is public, the user may proceed.
				route = (
					<Route {...this.props} component={this.props.component} />
				);
			}
		}

		return route;
	}
}

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/Navigation/AuthRoute/index.js